import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { API_BASE } from '../config';
import '../styles/adminproductos.css';

const AdminProductos = () => {
    const { token } = useAuth();
    const [poData, setPoData] = useState(null);
    const [checkedItems, setCheckedItems] = useState({});
    const { po_number, cart } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const fetchPoData = async () => {
            // First try to use order data from navigation state
            if (location.state?.orderData) {
                setPoData(location.state.orderData);
                return;
            }

            // If no order data in state, fetch from get-po endpoint
            if (!token) {
                console.error('No token available');
                return;
            }

            try {
                const response = await fetch(`${API_BASE}/get-po/?po_number=${po_number}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Token ${token}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setPoData(data);
                } else {
                    console.error('Failed to fetch PO data', response.status, response.statusText);
                    setPoData(null);
                }
            } catch (error) {
                console.error('Error:', error);
                setPoData(null);
            }
        };

        fetchPoData();
    }, [token, po_number, location.state]);

    const filteredProducts = poData?.items?.filter(item =>
        cart.includes('CART') ? !item.sku_frozen : item.sku_frozen
    ) || [];

    // The picker is tracked per PO+role on the backend: non-frozen carts (CART-)
    // map to item_responsable, frozen carts (BASKET-) map to frozen_responsable.
    const pickerResponsables = cart.includes('CART')
        ? poData?.item_responsable
        : poData?.frozen_responsable;
    const pickerNames = (pickerResponsables || [])
        .map(p => p.name)
        .filter(Boolean)
        .join(', ');

            const handleCheckCart = () => {
        console.log('AdminProductos - pickingStartTime from location.state:', location.state?.pickingStartTime);
        console.log('AdminProductos - Full location.state:', location.state);

        const storageKey = `pickingStartTime_${po_number}_${cart}`;
        const pickingStartTimeFromStorage = localStorage.getItem(storageKey);
        console.log('AdminProductos - pickingStartTime from localStorage:', pickingStartTimeFromStorage);

        // Use localStorage as fallback if location.state is null
        const pickingStartTime = location.state?.pickingStartTime || pickingStartTimeFromStorage;

        navigate(`/admin/${po_number}/${cart}/productos/check`, {
            state: {
                orderData: poData,
                pickingStartTime: pickingStartTime
            }
        });
    };

    const toggleItemCheck = (itemId, type) => {
        setCheckedItems(prev => {
            const newState = { ...prev };
            if (newState[itemId] === type) {
                delete newState[itemId];
            } else {
                newState[itemId] = type;
            }
            return newState;
        });
    };

    return (
        <div className="adminproductos-container">
            <button className="adminproductos-back-button" onClick={() => navigate(`/admin/${po_number}`)}>
                &#8592;
            </button>

            <h1 className="adminproductos-title">Productos pedido: {po_number}<br />{cart}</h1>

            {pickerNames && (
                <p className="adminproductos-picker">Pickeado por: {pickerNames}</p>
            )}

            <ul className="adminproductos-lista">
                {filteredProducts.length > 0 ? (
                    filteredProducts.map((item, index) => (
                        <li key={index} className="adminproductos-item">
                            <div className="adminproductos-item-details">
                                <span className="adminproductos-sku-name">{item.sku_name}</span>
                                <span className="adminproductos-item-quantity">Cantidad por {item.format_name}: {item.format_quantity}</span>
                                <span className="adminproductos-item-sku">SKU {item.sku_code}</span>
                            </div>
                            <div className="adminproductos-quantity-container">
                                <div className="adminproductos-quantity-box-container">
                                    <div className="adminproductos-quantity-box">
                                        {item.actual_quantity}
                                    </div>
                                    <span className="adminproductos-format-name">
                                        {item.format_unit_kg ? 'KG' : item.format_name}
                                    </span>
                                </div>
                                <div className="adminproductos-check-controls">
                                    <button
                                        className={`adminproductos-check-button ${checkedItems[item.sku_code] === 'check' ? 'checked' : ''}`}
                                        onClick={() => toggleItemCheck(item.sku_code, 'check')}
                                    >
                                        <svg viewBox="0 0 24 24" width="16" height="16">
                                            <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                                        </svg>
                                    </button>
                                    <button
                                        className={`adminproductos-cross-button ${checkedItems[item.sku_code] === 'cross' ? 'checked' : ''}`}
                                        onClick={() => toggleItemCheck(item.sku_code, 'cross')}
                                    >
                                        <svg viewBox="0 0 24 24" width="16" height="16">
                                            <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
                                        </svg>
                                    </button>
                                </div>
                                <div className={`adminproductos-status-indicator ${item.status}`}></div>
                            </div>
                        </li>
                    ))
                ) : (
                    <p className="adminproductos-empty">Cargando productos...</p>
                )}
            </ul>

            <div className="adminproductos-check-container">
                <button className="adminproductos-check-button" onClick={handleCheckCart}>
                    Chequear {cart.includes('CART') ? 'casillero' : 'frío'}
                </button>
            </div>
        </div>
    );
};

export default AdminProductos;
